import { css } from 'styled-components';
import { Breakpoints, Grids, Margins, MediaQueries } from './types';

export const transitionDuration = '0.2s';

export const breakpointMap: { [key: string]: number } = {
  unsupported: 743,
  small: 744,
  medium: 905,
  large: 1240,
  xLarge: 1440
};

export const marginsMap: { [key: string]: number } = {
  small: 48,
  medium: 80,
  large: 96
};

export const gridsMap: {
  [key: string]: { gridColumns: number };
} = {
  small: { gridColumns: 8 },
  medium: { gridColumns: 12 },
  large: { gridColumns: 12 },
  xLarge: { gridColumns: 12 }
};

const breakpoints: Breakpoints = Object.values(breakpointMap).map(
  breakpoint => `${breakpoint}px`
);

const mediaQueries: MediaQueries = {
  unsupported: `@media screen and (max-width: ${breakpointMap.unsupported}px)`,
  small: `@media screen and (min-width: ${breakpointMap.small}px)`,
  medium: `@media screen and (min-width: ${breakpointMap.medium}px)`,
  large: `@media screen and (min-width: ${breakpointMap.large}px)`,
  xLarge: `@media screen and (min-width: ${breakpointMap.xLarge}px)`
};

const grids: Grids = {
  small: `grid-template-columns: repeat(${gridsMap.small.gridColumns}, minmax(0, 1fr));`,
  medium: `grid-template-columns: repeat(${gridsMap.medium.gridColumns}, minmax(0, 1fr));`,
  large: `grid-template-columns: repeat(${gridsMap.large.gridColumns}, minmax(0, 1fr));`,
  xLarge: `grid-template-columns: repeat(${gridsMap.xLarge.gridColumns}, minmax(0, 1fr));`
};

const responsiveMargins = css`
  ${({ theme }) => theme.mediaQueries.small} {
    margin: ${({ theme }) => theme.margins.small};
  }
  ${({ theme }) => theme.mediaQueries.medium} {
    margin: ${({ theme }) => theme.margins.medium};
  }
  ${({ theme }) => theme.mediaQueries.large} {
    margin: ${({ theme }) => theme.margins.large};
  }
  ${({ theme }) => theme.mediaQueries.xLarge} {
    margin: ${({ theme }) => theme.margins.xLarge};
  }
`;

const margins: Margins = {
  small: `0px ${marginsMap.small}px`,
  medium: `0px ${marginsMap.medium}px`,
  large: `0px ${marginsMap.large}px`,
  xLarge: '0px auto'
};

export default {
  breakpoints,
  mediaQueries,
  margins,
  responsiveMargins,
  grids,
  transitionDuration
};
